import type { TransportLine } from '../../shared/domain/index.ts';

/** Pictogramme de ligne aux couleurs officielles du référentiel IDFM. */
export function LineBadge({ line, size = 'md' }: { line: TransportLine; size?: 'sm' | 'md' }) {
  return (
    <span
      className={`line-badge line-badge--${size}`}
      style={{ background: line.color ?? 'var(--surface-2)', color: line.textColor ?? 'var(--text)' }}
      title={line.name}
    >
      <span aria-hidden="true">{line.code}</span>
      <span className="visually-hidden">{line.name}</span>
    </span>
  );
}
